import React, { useEffect } from 'react';
import { useParams, Navigate } from 'react-router-dom';
import inductionModules, { INDUCTION_PROGRESS_KEY } from '../../data/inductionModules';
import ModuleBlocks from './ModuleBlocks';
import ModuleFooterNav from './ModuleFooterNav';

const markVisited = (moduleId) => {
  try {
    const raw = localStorage.getItem(INDUCTION_PROGRESS_KEY);
    const visited = raw ? JSON.parse(raw) : [];
    if (!visited.includes(moduleId)) {
      localStorage.setItem(INDUCTION_PROGRESS_KEY, JSON.stringify([...visited, moduleId]));
    }
  } catch (e) {
    // localStorage unavailable — progress is a convenience only
  }
};

const InductionModule = () => {
  const { moduleId } = useParams();
  const id = /^\d+$/.test(moduleId) ? parseInt(moduleId, 10) : NaN;
  const module = inductionModules.find((m) => m.id === id);

  useEffect(() => {
    if (module) {
      markVisited(module.id);
    }
  }, [module]);

  if (!module) {
    return <Navigate to="/induction" replace />;
  }

  return (
    <div style={{ maxWidth: '800px', margin: '0 auto' }}>
      <p style={{ color: '#555', marginBottom: '4px' }}>Module {module.id} of {inductionModules.length}</p>
      <h1>{module.title}</h1>
      <p style={{ color: '#555' }}>{module.durationMinutes} minute{module.durationMinutes === 1 ? '' : 's'}</p>
      <ModuleBlocks blocks={module.blocks} />
      <ModuleFooterNav moduleId={module.id} totalModules={inductionModules.length} />
    </div>
  );
};

export default InductionModule;
